/**
 * Route for `clevertap-2-way-apptrove-native-sync`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { Clevertap2WayApptroveNativeSyncPage } from "../features/clevertap-2-way-apptrove-native-sync/Clevertap2WayApptroveNativeSyncPage";

export const clevertap2WayApptroveNativeSyncRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/clevertap-2-way-apptrove-native-sync",
	component: Clevertap2WayApptroveNativeSyncPage,
});

export default clevertap2WayApptroveNativeSyncRoute;
